import { cn } from "@/lib/utils";
import { type ComponentProps, splitProps } from "solid-js";

export default function RootLayout(props: ComponentProps<"div">) {
  const [local, rest] = splitProps(props, ["children", "class"]);

  return (
    <div
      class={cn(
        "flex h-dvh min-h-dvh flex-1 flex-col overscroll-x-contain",
        local.class,
      )}
      {...rest}
    >
      {local.children}
    </div>
  );
}
